
































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import Language from "@/models/language/language.model";
import LanguageGroup from '@/models/language/languageGroup/languageGroup.model';
@Component
export default class LanguageLabelBase extends BaseVue {

  protected languageId: number | null = null;
  protected languageGroupId: number | null = null;
  protected loading = false;
  protected repositoryLanguage!: BaseRepository<Language>;
  protected repositoryLanguageGroup!: BaseRepository<LanguageGroup>;

  protected modelLanguage: Language | any = null;
  protected modelLanguageGroup: Language | any = null;

  created() {
    this.languageId = Number.parseInt(this.$route.params.languageId);
    this.languageGroupId = Number.parseInt(
      this.$route.params.languageGroupId
    );

    if (
      this.hasParent &&
      this.modelLanguage == null &&
      this.modelLanguageGroup == null
    ) {
      this.repositoryLanguage = new BaseRepository<Language>(
        "Languages"
      );
      this.repositoryLanguageGroup = new BaseRepository<Language>(
        "LanguageGroups"
      );
      this.getData();
    }
  }
  get nameLanguage() {
    return this.hasParent && this.modelLanguage
      ? this.modelLanguage.name
      : "---";
  }
  get nameLanguageGroup() {
    return this.hasParent && this.modelLanguageGroup
      ? this.modelLanguageGroup.name
      : "---";
  }
  gotToListLanguage() {
    this.$router.push("/Language");
  }
  gotToListLanguageGroup() {
    this.$router.push(`/Language/${this.languageId}/LanguageGroup`);
  }
  protected async getData() {
    try {
      
      if (this.languageId && this.languageGroupId)
        this.modelLanguage = await this.repositoryLanguage.getById(
          this.languageId
        );
      this.modelLanguageGroup = await this.repositoryLanguageGroup.getById(
        this.languageGroupId as any
      );
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
     
    }
  }
  get hasParent() {
    return (
      !!this.$route.params.languageId &&
      !!this.$route.params.languageGroupId
    );
  }
}
